import type { BookingAnalyticsDurationBucket } from "@/queries/analytics/booking-reporting-types";

export function isDurationInBucket(durationHours: number, bucket: BookingAnalyticsDurationBucket): boolean {
  switch (bucket) {
    case "upTo1Hour":
      return durationHours <= 1;
    case "1To2Hours":
      return durationHours > 1 && durationHours <= 2;
    case "2To4Hours":
      return durationHours > 2 && durationHours <= 4;
    case "4To8Hours":
      return durationHours > 4 && durationHours <= 8;
    case "moreThan8Hours":
      return durationHours > 8;
  }
}
